export const ROOT_PATH = '/';
export const LOGIN_PATH = '/login';
